import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "file-item__title" }
const _hoisted_3 = {
  key: 0,
  class: "row items-center"
}
const _hoisted_4 = { class: "file-item__size q-ml-sm text-grey" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "file-item__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-item col-6", { 'last-item': _ctx.isLastItem }])
  }, [
    _createElementVNode("img", {
      class: "logo__image-wrapper",
      src: require(`../assets/images/information-page/${_ctx.file.icon}`)
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.file.title), 1),
    (_ctx.haveFileUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_q_btn, {
            class: "s-btn-inverse",
            size: "small",
            "no-caps": "",
            label: _ctx.file.file_type,
            outline: "",
            loading: _ctx.loading,
            onClick: _ctx.downloadFile
          }, null, 8, ["label", "loading", "onClick"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.file.file_size) + " Мб ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.haveDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.file.description), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}